import { render, staticRenderFns } from "./ProductPostpaid.vue?vue&type=template&id=62789b32&"
import script from "./ProductPostpaid.vue?vue&type=script&lang=js&"
export * from "./ProductPostpaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports